import { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { CollaboratoreFields } from "./CollaboratoriEditor";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Loader2, Check } from "lucide-react";
import { toast } from "sonner";

const EMPTY = { nome: "", cognome: "", codice_fiscale: "", data_nascita: "", indirizzo: "", email: [], cellulare: [] };

// Inserimento rapido di un collaboratore su un professionista esistente (dalla scheda pratica).
export default function CollaboratoreDialog({ open, atype, proId, proName, existing = [], editIndex = null, onSaved, onCancel }) {
  const isEdit = editIndex !== null && editIndex >= 0;
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (open) setForm(isEdit ? { ...EMPTY, ...existing[editIndex] } : EMPTY); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const save = async () => {
    if (!(form.nome || form.cognome)) { toast.error("Inserisci almeno nome o cognome"); return; }
    setSaving(true);
    try {
      const list = Array.isArray(existing) ? existing : [];
      const next = isEdit ? list.map((c, i) => (i === editIndex ? form : c)) : [...list, form];
      await api.patch(`/anagrafiche/${atype}/${proId}`, { collaboratori: next });
      toast.success(isEdit ? "Collaboratore aggiornato" : "Collaboratore aggiunto");
      onSaved?.(form);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={!!open} onOpenChange={(o) => { if (!o) onCancel?.(); }}>
      <DialogContent className="bg-[#121824] border-slate-700 text-slate-100 max-w-lg max-h-[85vh] overflow-y-auto" data-testid="collaboratore-dialog">
        <DialogHeader><DialogTitle className="font-head">{isEdit ? "Modifica collaboratore" : "Nuovo collaboratore"}{proName ? ` · ${proName}` : ""}</DialogTitle></DialogHeader>
        <CollaboratoreFields value={form} onChange={setForm} idPrefix="new-collab" />
        <div>
          <label className="text-slate-300 text-xs font-medium">Note</label>
          <textarea value={form.note || ""} rows={3} placeholder="Annotazioni libere…" data-testid="collaboratore-note"
            onChange={(e) => { setForm((f) => ({ ...f, note: e.target.value })); e.target.style.height = "auto"; e.target.style.height = `${e.target.scrollHeight}px`; }}
            className="mt-1 w-full min-h-[80px] resize-y rounded-md border border-slate-700 bg-slate-900/60 px-3 py-2 text-sm text-slate-100 focus:outline-none focus:ring-1 focus:ring-amber-500/60" />
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => onCancel?.()} data-testid="collaboratore-cancel" className="border-slate-700 text-slate-200 hover:bg-slate-800">Annulla</Button>
          <Button onClick={save} disabled={saving} data-testid="collaboratore-save" className="bg-amber-500 hover:bg-amber-600 text-[#0a0d14] font-semibold">{saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Check className="h-4 w-4 mr-1" /> Salva collaboratore</>}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
